import { DataReadinessTab } from "./DataReadinessTab";

export default DataReadinessTab;
